<template>
  <div class="course-detail-wrapper">
    <div class="workshop" v-if="dataDone">
      <!-- 封面 -->
      <div class="workshop-cover" :class="{'status-bar': (courseData.status == 1 && !isStop) || courseData.status == 2}">
        <img :src="courseData.thumb">
        <div class="cover-info" :class="{'soon': (courseData.status == 1 && courseData.stopSoon)}" v-if="courseData.status == 1 && !isStop">
          <div class="cover-tips">
            <span class="iconfont icon-new-clock"></span>
            报名截止时间: {{courseData.stopApplyTime}}
          </div>
          <div class="sign-info">
            <div>报名人数</div>
            <div>{{courseData.enrollers_student}} / {{courseData.student_limit}} 人</div>
          </div>
        </div>
        <div class="cover-info" v-else-if="courseData.status == 2">
          <div class="cover-tips">
            <span class="iconfont icon-user-circle"></span>
            {{courseData.reservers}}人已设置开课提醒
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="base-info">
        <div class="title">{{courseData.title}}</div>
        <div class="sub-title new-course" v-if="courseData.is_new == 1 && courseData.status == 1">新课上线</div>
        <div class="sub-title" v-else>课程评分 {{courseData.average_score}} 分丨已上过 {{courseData.enrollers || 0}} 人</div>
        <div class="info-block">
          <div class="info-item" v-if="courseData.status == 1">
            <span class="type">上课时间</span>
            <div class="content">
              <div>{{courseData.formatTime}}<span>本地时间</span></div>
              <div>{{courseData.bj_time}}<span>北京时间</span></div>
            </div>
          </div>
          <div class="info-item" v-else-if="courseData.status == 2">
            <span class="type">上课时间</span>
            <div class="content">待发布</div>
          </div>
          <div class="info-item">
            <span class="type">时长</span>
            <div class="content">{{courseData.minutes | classTimeTransform}}<!-- （{{courseData.minutes / 60 * 3}}凯诺币） --></div>

          </div>
          <div class="info-item">
            <span class="type">难度</span>
            <div class="content">{{courseData.course_level}}</div>
          </div>
        </div>
      </div>
      <div class="course-main-wrapper">
        <div class="tab-wrapper" ref="courseTab">
          <div class="course-tab" :class="{'fixed': tabFixed}">
            <div class="tab-item" :class="{'active': activeTab == 'info'}" @click="tab('info')">课程信息</div>
            <div class="tab-item" :class="{'active': activeTab == 'comments'}" @click="tab('comments')" v-if="comments.length > 0">学生评价</div>
            <div class="tab-item" :class="{'active': activeTab == 'other'}" @click="tab('other')">相关课程</div>
          </div>
        </div>
        <!-- 课程内容 -->
        <div class="course-info-main" ref="courseMain">
          <div class="course-block" v-if="courseDetail.preface">
            <div class="info-content preface">
              <div class="rich-text" v-html="courseDetail.preface"></div>
            </div>
          </div>
          <div class="course-block">
            <div class="info-title">指导老师</div>
            <div class="info-content">
              <router-link :to="{name: 'LecturerDetail', params: {id: courseData.uid}}" class="course-teacher" v-if="courseData.trained == 1">
                <div class="teacher-avatar"><img :src="courseData.avatar"></div>
                <div class="teacher-info">
                  <div class="teacher-name">{{courseData.teacher_name}}</div>
                  <div class="teacher-title-box">
                    <div class="teacher-title">{{courseData.title1}}</div>
                    <div class="teacher-title">{{courseData.title2}}</div>
                  </div>
                </div>
              </router-link>
              <div class="course-teacher" v-else>
                <div class="teacher-avatar"><img :src="courseData.avatar"></div>
                <div class="teacher-info">
                  <div class="teacher-name">{{courseData.teacher_name}}</div>
                  <div class="teacher-title-box">
                    <div class="teacher-title">{{courseData.title1}}</div>
                    <div class="teacher-title">{{courseData.title2}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="course-block" v-if="courseDetail.goal">
            <div class="info-title">课程目标</div>
            <div class="info-content">
              <div class="rich-text" v-html="courseDetail.preface"></div>
            </div>
          </div>
          <div class="course-block">
            <div class="info-title">专业方向</div>
            <div class="info-content">
              <div class="major-info"><text>授课方向</text>{{courseData.course}}</div>
              <div class="major-info"><text>适用专业</text>{{courseData.major}}</div>
              <div class="major-info"><text>涉及软件</text>{{courseData.software}}</div>
            </div>
          </div>
          <div class="course-block" v-if="courseDetail.requirement">
            <div class="info-title">课前要求</div>
            <div class="info-content">
              <div class="rich-text" v-html="courseDetail.requirement"></div>
            </div>
          </div>
          <div class="course-block" v-if="courseDetail.content">
            <div class="info-title">课程内容</div>
            <div class="info-content">
              <div class="rich-text" v-html="courseDetail.content"></div>
            </div>
          </div>
        </div>
        <!-- 课评 -->
        <div class="course-comment" ref="courseComment" v-if="comments.length > 0">
          <div class="comments-head">
            <div class="total-score">{{courseData.average_score || 0}}</div>
            <div class="score-text">
              <div class="text">课程评分 ({{commentsCount || 0}})</div>
              <div class="score-box">
                <icon icon-class="star" :class-name="Math.round(courseData.average_score) >= 1 ? '' : 'disabled'"></icon>
                <icon icon-class="star" :class-name="Math.round(courseData.average_score) >= 2 ? '' : 'disabled'"></icon>
                <icon icon-class="star" :class-name="Math.round(courseData.average_score) >= 3 ? '' : 'disabled'"></icon>
                <icon icon-class="star" :class-name="Math.round(courseData.average_score) >= 4 ? '' : 'disabled'"></icon>
                <icon icon-class="star" :class-name="Math.round(courseData.average_score) >= 5 ? '' : 'disabled'"></icon>
              </div>
            </div>
          </div>
          <div class="tags-list" v-if="commentsTags.length > 0">
            <div class="tag-item" v-for="(item, index) in commentsTags" :key="index">{{item.tag}}<span>({{item.count}})</span></div>
          </div>
          <div class="comments-list">
            <div class="title">学生评价({{comments.length}})</div>
            <div class="comment-item" v-for="comment in comments" :key="comment.id">
              <div class="comment-avatar lazy-load-small">
                <img v-if="comment.anonymous == '0'" :src="comment.avatar" alt="">
                <img v-if="comment.anonymous == '1'" src="/Application/Home/Resource/static/images/user-default-avatar.jpg">
              </div>
              <div class="comment-content">
                <div class="comment-name">
                  <span v-if="comment.anonymous == 0">{{comment.username}}</span>
                  <span v-if="comment.anonymous == 1">匿名</span>
                </div>
                <div class="comment-text">{{comment.content}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他课程 -->
        <div class="about-workshop" ref="aboutCourse">
          <div class="about-title">
            <div class="title">相关课程</div>
            <div class="reload-about" @click="getAboutCourse"><icon icon-class="reupload"></icon>换一批</div>
          </div>
          <div class="about-list" v-if="aboutCourse.length > 0">
            <router-link :to="item.href" class="about-card" v-for="item in aboutCourse" :key="item.cid">
              <div class="course-cover lazy-load"><img :src="item.thumb" alt=""></div>
              <div class="course-info">
                <div class="type" :class="'type-' + item.type">{{item.type | courseType}}</div>
                <div class="about-course-title">{{item.title}}</div>
              </div>
            </router-link>
          </div>
          <div class="no-about-course" v-else>没有相关课程</div>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="workshop-control" :class="{'iphonex': isIPhoneX}">
        <!-- 去PC端操作 -->
        <div class="control-item">
          <icon icon-class="new-sign"></icon>
          <div class="control-text">请到官网或微信小程序报名</div>
        </div>
        <!-- 分享 -->
        <div class="control-item share" @click="share">
          <icon icon-class="new-share"></icon>
          <div class="control-text">分享</div>
        </div>
      </div>
      <share :src="locationHref" :title="courseData.title" type="小组课" ref="shareComponent"></share>
    </div>
  </div>
</template>

<style lang="less" scoped>
@workshop: #4DA2C7;
@cano: #4DA2C7;
  .workshop{
    width: 100%;
    position: relative;
    padding-bottom: 48px;
    &.iphonex{
      padding-bottom: 67px;
    }
    .workshop-cover{
      position: relative;
      width: 100%;
      height: 2rem;
      background-color: #EEE;
      overflow: hidden;
      &.status-bar{
        padding-bottom: .34rem;
      }
      .cover-info{
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: .34rem;
        background: @cano;
        color: #FFF;
        padding: 0 .16rem;
        font-size: 14px;
        &.soon{
          background: #F85C5C;
        }
        .cover-tips{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .iconfont{
            margin-right: 6px;
            font-size: 12px;
          }
        }
        .sign-info{
          font-size: 12px;
          line-height: 14px;
        }
      }
      img{
        width: 100%;
        transform: translateY(-16%);
      }
    }
    .base-info{
      margin-top: .2rem;
      padding: 0 .16rem;
      .title{
        font-size: 18px;
        line-height: 20px;
        color: #333;
        font-weight: bold;
      }
      .sub-title{
        font-size: 12px;
        line-height: 12px;
        color: #666;
        margin-top: 6px;
        &.new-course{
          color: @cano;
        }
      }
      .info-block{
        margin-top: .09rem;
        font-size: 14px;
        color: #666;
        line-height: 20px;
        .info-item{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
          line-height: 36px;
          font-size: 14px;
          border-bottom: 1px solid #F6F7F8;
          &:last-child{
            border-bottom: 0;
          }
          .type{
            color: #333;
            width: 72px;
            text-align: left;
            color: #333;
            font-weight: bold;
            white-space: nowrap;
          }
          .content{
            width: calc(~"100% - 72px");
            color: #666;
            div{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              border-bottom: 1px solid #F6F7F8;
              &:last-child{
                border-bottom: 0;
              }
              span{
                display: inline-block;
                margin-left: 12px;
                height: 18px;
                line-height: 18px;
                padding: 0 6px;
                background: #F7F7F7;
                color: #666;
                font-size: 11px;
                border-radius: 18px;
              }
            }
          }
        }
      }
    }
    .course-main-wrapper{
      padding-top: 20px;
      .tab-wrapper{
        height: 34px;
        .course-tab{
          box-sizing: border-box;
          padding: 0 16px;
          background: #FFF;
          border-bottom: 1px solid #EEEEEE;
          height: 34px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &.fixed{
            position: fixed;
            top: 87px;
            left: 0;
            width: 100%;
          }
          .tab-item{
            position: relative;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            color: #999;
            margin-right: 16px;
            &.active{
              color: #333;
              font-weight: bold;
              &::after{
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 24px;
                height: 3px;
                border-radius: 3px;
                background: @cano;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .course-info-main{
        padding: 0 24px;
        .course-block{
          padding: 20px 0;
          border-bottom: 1px solid #F6F7F8;
          color: #666666;
          &:last-child{
            border-bottom: 0;
          }
          .info-title{
            font-size: 16px;
            line-height: 16px;
            color: #333;
            font-weight: bold;
          }
          .info-content{
            margin-top: 16px;
            font-size: 14px;
            line-height: 21px;
            color: #666;
            &.preface{
              margin-top: 0;
            }
            .rich-text{
              font-size: 14px;
              line-height: 21px;
              color: #666;
              img{
                max-width: 100%!important;
                height: auto;
              }
            }
            .major-info{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              font-size: 14px;
              color: #666;
              margin-bottom: 6px;
              word-break: break-all;
              max-width: 100%;
              spantext{
                width: 144rpx;
                min-width: 144rpx;
                color: #333;
                white-space: nowrap;
              }
            }
            .course-teacher{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .teacher-avatar{
                width: 64px;
                height: 64px;
                overflow: hidden;
                border-radius: 50%;
                box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .teacher-info{
                padding-left: 16px;
                font-size: 14px;
                color: #333;
                .teacher-name{
                  line-height: 14px;
                }
                .teacher-title-box{
                  margin-top: 8px;
                  color: #999;
                  font-size: 12px;
                  line-height: 12px;
                  .teacher-title{
                    max-width: 260px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    &:first-child{
                      margin-bottom: 6px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .course-comment{
        padding: 0 24px;
        border-top: 10px solid #F8F8F8;
        // min-height: 100vh;
        .comments-head{
          padding: 25px 0 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .total-score{
            font-size: 42px;
            line-height: 38px;
            color: #4BA8C9;
            font-weight: 500;
          }
          .score-text{
            padding-left: 16px;
            font-size: 16px;
            color: #333;
            .text{
              font-size: 14px;
              color: #333;
              line-height: 14px;
              margin-bottom: 5px;
            }
            .score-box{
              color: #4BA8C9;
              font-size: 14px;
              svg{
                color: @cano;
              }
              .disabled{
                color: #999;
              }
            }
          }
        }
        .tags-list{
          padding-bottom: 8px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          .tag-item{
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 12px;
            height: 28px;
            background: #F3F3F3;
            margin: 0 12px 12px 0;
            font-size: 12px;
            color: #666;
            border-radius: 28px;
            span{
              color: #999;
            }
          }
        }
        .comments-list{
          padding: 20px 0;
          border-top: 1px solid #F6F7F8;
          .title{
            font-size: 16px;
            line-height: 16px;
            color: #333;
            font-weight: bold;
          }
          .comment-item{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            margin-top: 16px;
            border-bottom: 1px solid #F6F7F8;
            .comment-avatar{
              box-sizing: border-box;
              width: 44px;
              min-width: 44px;
              height: 44px;
              background: rgba(255,255,255,.18);
              padding: 3px;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 38px;
                height: 38px;
                border-radius: 50%;
                box-shadow: 0 2px 6px 0 rgba(0,0,0,.06);
              }
            }
            .comment-content{
              padding: 0 0 16px 12px;
              margin-top: 11px;
              .comment-name{
                font-size: 14px;
                line-height: 14px;
                color: #333;
              }
              .comment-text{
                font-size: 14px;
                line-height: 18px;
                color: #666;
                margin-top: 13px;
              }
            }
          }
        }
      }
      .about-workshop{
        border-top: 10px solid #F3F3F3;
        padding: 24px;
        .about-title{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title{
            font-size: 18px;
            line-height: 18px;
            color: #333;
            font-weight: 600;
          }
          .reload-about{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: @cano;
            cursor: pointer;
            font-size: 14px;
            line-height: 14px;
            svg{
              font-size: 14px;
              margin-right: 4px;
            }
          }
        }
        .about-list{
          margin-top: 16px;
          .about-card{
            display: flex;
            margin-bottom: 12px;
            height: .8rem;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            overflow: hidden;
            .course-cover{
              flex-shrink: 0;
              width: .97rem;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                height: 100%;
              }
            }
            .course-info{
              padding: .16rem 0 0 12px;
              flex: 1;
              min-width: 0;
              .type{
                font-size: 14px;
                line-height: 14px;
                &.type-1{
                  color: @workshop;
                }
                &.type-2{
                  color: #ac83e9;
                }
                &.type-3{
                  color: #43c593;
                }
                &.type-4{
                  color: #45c6c7;
                }
              }
              .about-course-title{
                margin-top: .08rem;
                font-size: 15px;
                line-height: 22px;
                color: #333;
                font-weight: 500;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 2rem;
              }
            }
          }
        }
      }
    }
    /* 小组课底部操作 */
    .workshop-control{
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: 48px;
      border-top: 1px solid #BDBDBD;
      background-color: #fff;
      z-index: 990;
      &.iphonex{
        height: 67px;
      }
      .control-item{
        position: relative;
        box-sizing: border-box;
        // flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        background-color: transparent;
        border: 0;
        color: #333;
        padding: 0 36px;
        &::after{
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 18px;
          background: #F6F7F8;
          transform: translateY(-50%);
        }
        &:first-child{
          color: @cano;
        }
        &:last-child::after{
          background-color: transparent;
        }
        .control-text{
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
</style>

<script>
  import Utils from '@/untils/utils'
  import share from '@/components/Common/share.vue'
  export default {
    data() {
      return {
        // 数据加载状态
        dataDone: false,
        isIPhoneX: false,
        // 课程信息
        courseData: {},
        courseDetail: {},
        // 是否已截止报名
        isStop: false,
        tabFixed: false,
        activeTab: 'info',
        // tab顶部偏移值
        tabOffset: 0,
        tabFixed: false,
        // 评论内容高度偏移值
        commentOffset: 0,
        // 相关课程高度偏移
        aboutOffset: 0,
        // 课程评价
        comments: [],
        commentsCount: null,
        commentsTags: [],
        // 相关课程
        aboutCourse: [],
        // 相关课程当前页数
        currentAbout: 0,
        locationHref: '',
      }
    },
    watch: {
      '$route'() {
        // 跳转其他课程详情时重新获取数据
        this.id = this.$route.params.id;
        this.locationHref = window.location.href;
        this.getBaseInfo();
        $(document).scrollTop(0);
      }
    },
    components: {
      share
    },
    created() {
      this.locationHref = window.location.href;
      this.getBaseInfo();
    },
    methods: {
      // 获取切换tab的顶部偏移值
      getTabOffset() {
        this.tabOffset = this.$refs.courseTab.offsetTop;
      },
      // 获取&刷新每个内容区块的高度偏移值
      refreshOffset() {
        if(this.comments.length > 0) this.commentOffset = this.$refs.courseComment.offsetTop;
        if(this.aboutCourse.length > 0) this.aboutOffset = this.$refs.aboutCourse.offsetTop;
      },
      tab(type) {
        // this.activeTab = type;
        switch(type) {
          case 'info': {
            $("html,body").animate({scrollTop: this.tabOffset}, 500, () => {this.activeTab = type;});
          };break;
          case 'comments': {
            $("html,body").animate({scrollTop: this.commentOffset}, 500, () => {this.activeTab = type;});
          };break;
          case 'other': {
            $("html,body").animate({scrollTop: this.aboutOffset}, 500, () => {this.activeTab = type;});
          }
        }
      },
      getBaseInfo() {
        this.$root.post('/Course/get_workshop_info', {
          cid: this.$route.params.id
        }).then(data => {
          this.dataDone = true;
          // 开课时间
          const starttimeStamp = data.starttime * 1000;
          const endtimeStamp = data.endtime * 1000;
          data.formatTime = `${Utils.formatTimeToYear(new Date(starttimeStamp))}${Utils.formatTimeToDay(new Date(starttimeStamp))} ${Utils.formatTimeToMoinute(new Date(starttimeStamp))} - ${Utils.formatTimeToMoinute(new Date(endtimeStamp))}`;
          // 报名截止时间
          const courseStopApplyTime = (data.starttime - 14400) * 1000;
          data.stopApplyTime = `${Utils.formatTimeToDay(new Date(courseStopApplyTime))} ${Utils.formatTimeToMoinute(new Date(courseStopApplyTime))}`
          // 报名截止前一天
          data.stopSoon = (courseStopApplyTime - new Date().getTime()) <= 86400000 ? true : false;
          // 格式化适用专业，设计特点
          data.course = data.course.join(',');
          data.major = data.major.join('/');
          this.courseData = data;
          // 课程是否已截止 开课前四小时截止
          this.isStop = (data.starttime - new Date().getTime() / 1000) <= 14400 ? true : false;
          // 将报名数量转为数字类型
          this.courseData.enrollers_student = parseInt(this.courseData.enrollers_student);
          this.courseData.student_limit = parseInt(this.courseData.student_limit);
          this.courseData.enrollers_teacher = parseInt(this.courseData.enrollers_teacher);
          this.courseData.teacher_limit = parseInt(this.courseData.teacher_limit);
          this.$nextTick(() => {
            // 获取基本信息后初始化百度分享设置
            window._bd_share_config = {
              common: {
                bdText: `《${this.courseData.title}》 - 凯诺设计课 Canopy Institute of Design`, //分享的内容
                bdUrl: window.location.href, //分享的url
                bdPic: document.domain + this.courseData.thumb, //分享的图片
                bdSign: 'off' //禁用回流
              },
              share : [{
                bdCustomStyle: ' '
              }]
            }
            let shareScript = document.createElement('script');
            shareScript.src = '/Application/Home/Resource/vendor/bdShare/static/api/js/share.js?cdnversion='+~(-new Date()/36e5);
            document.getElementsByTagName('body')[0].appendChild(shareScript);

            // 获取tab偏移值&刷新每个内容区块的高度偏移值
            this.getTabOffset();
            $(document).scroll(() => {
              let scrollTop = $(document).scrollTop()
              this.tabFixed = (scrollTop >= this.tabOffset) ? true : false;
              if(scrollTop >= this.commentOffset && this.commentOffset != 0) {
                this.activeTab = 'comments';
              }else if(scrollTop >= this.aboutOffset && this.aboutOffset != 0) {
                this.activeTab = 'other';
              }else {
                this.activeTab = 'info';
              }
            })
          })

          // 获取课程详情
          this.$root.post('/Course/get_workshop_detail', {
            cid: this.$route.params.id,
            is_mobile: 1,
          }).then(detail => {
            // 控制课程内容信息图片的宽度
            detail.content = detail.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            this.courseDetail = detail;
          })
          // 获取评论
          this.$root.post('/Course/get_workshop_comment', {
            cid: this.$route.params.id
          }).then(comments => {
            if (comments) {
              comments.info.forEach(item => {
                // 匿名
                item.username = item.anonymous == '1' ? '匿名' : item.username;
              })
              this.comments = comments.info;
              this.commentsCount = comments.count;
              this.commentsTags = comments.comment_tags || [];
              this.$nextTick(() => {
                this.refreshOffset();
              })
            }
          })
          this.getAboutCourse();
        })
      },
      getAboutCourse() {
        // 获取相关课程内容
        this.$root.post('/Course/get_correlation_course', {
          cid: this.$route.params.id,
          page: this.currentAbout,
          type: 1
        }).then(list => {
          if (list.info) {
            this.aboutCourse = list.info;
            this.aboutCourse.forEach(item => {
              switch(item.type) {
                case 1:
                  item.href = '/course/workshop/' + item.cid;
                  break;
                case 2:
                  item.href = '/course/studio/' + item.cid;
                  break;
                case 3:
                  item.href = '/course/openlecture/' + item.cid;
                  break;
              }
            })
            // 判断相关课程数量决定是否归1 / 更新当前相关课程页数
            this.currentAbout = parseInt(list.page) == 0 ? 1 : this.currentAbout + 1;
            this.$nextTick(() => {
              this.refreshOffset();
            })
          }
        })
      },
      share() {
        this.$refs.shareComponent.showMenu();
      }
    },
    filters: {
      // 课程时长转换
      classTimeTransform(minutes) {
        if(!minutes) return '';
        if (typeof minutes == 'string') {
          minutes = parseInt(minutes)
        }
        switch (minutes) {
          case 60: return '1小时';break;
          case 90: return '1.5小时'; break;
          case 120: return '2小时'; break;
          default: return minutes + '分钟';
        }
      },
      courseType(type) {
        switch(type) {
          case 1: return '小组课';break;
          case 2: return '设计室';break;
          case 3: return '公开课';break;
          case 4: return '一对一';break;
          case 5: return '免费视频';break;
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CourseDetail/workshop.vue